module.exports = "img/create-big.216a289.svg";